import { TokenService } from "deliziora-client-module/client-web";
import { useEffect, useRef, useState } from "react";
import { useParams, useNavigate, Navigate } from "react-router-dom";
import LoadingPage from "../Pages/PageLoading/PageLoading";

export default function ProtectedRouteWithUUIDCheck({ children, tokenUsed }) {
  const { uuid } = useParams();
  const [loading, setLoading] = useState(true);
  const [tokenValid, setTokenValid] = useState(true);

  useEffect(() => {
    TokenService.getTokenByUuid(uuid)
      .then((res) => {
        setLoading(false);
        console.log(res.data);
        setTokenValid(res.data.used);
        if (res.data.used === false) {
          TokenService.updateTokenUsed(uuid)
            .then((response) => {
              console.log("token usado");
            })
            .catch((error) => {
              console.log("erro ao atualizar o token para used = true");
            });
        }
      })
      .catch((error) => {
        console.log("404");
        setLoading(false);
        setTokenValid(true)
      });
  }, []);
  return (
    <>
      {loading ? (
        <>
          <LoadingPage />
        </>
      ) : (
        <>{!tokenValid ? children : <Navigate to={"/401"} />}</>
      )}
    </>
  );
}
